import React from 'react'

import {PageTitle} from '../../components';

import Layout from '../../components/about/Layout';


export default () => (
  <Layout>
    <PageTitle title='资质荣誉'/>
  </Layout>
)


// WEBPACK FOOTER //
// ./src/pages/about/honor.js